module.exports = __webpack_public_path__ + "static/media/subscription1.8561bc42.jpg";